import { COLUMN_COMPANY, COLUMN_UNIQUE_IDENTIFIER, COLUMN_COMMON_ZONE, COLUMN_TAG_CODE, COLUMN_DATE_TIME, COLUMN_DEPARTMENT, COLUMN_DISPLAY_NAME, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_SITE, COLUMN_SUFFIX, COLUMN_TITLE, COLUMN_ZONE, COLUMN_SECOND_NAME } from "../../constants/column-types";
import { FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_SITES, FILTER_TAGHOLDERS, FILTER_ZONES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const ZoneOccupanyColumns: TableColumn[] = [
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 0,
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
        lookupName: "mstDisplayname",
        searchOnName: "masterId",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master',
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 3,
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 4,
        sortByName: "mstMiddlename",
        sortDirection: "asc",
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 5,
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        id: 6,
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 7,
        active: true,
        lookupName: "department.id",
        searchOnName: "department.id",
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: 'department'
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 8,
        //sortByName: "trCompName",
        lookupName: "company.id",
        searchOnName: "company.id",
        //sortDirection: "asc",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: 'company'
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 9,
        searchOnName: "site.id",
        lookupName: "site.id",
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site'
    },
    {
        heading: "Zone",
        accessor: "zone",
        isNumeric: false,
        lookupName: "zone.id",
        searchOnName: "zone.id",
        id: 10,
        active: true,
        translationKey: "zone",
        columnId: COLUMN_ZONE,
        filterId: FILTER_ZONES,
        settingDataName: 'zone'
    },
    {
        heading: "Common Zone",
        accessor: "commonZone",
        isNumeric: false,
        id: 11,
        active: false,
        translationKey: "commonZone",
        columnId: COLUMN_COMMON_ZONE
    },
    {
        heading: "Date Time",
        accessor: "dateTime",
        isNumeric: false,
        id: 12,
        active: true,
        translationKey: "dateTime",
        columnId: COLUMN_DATE_TIME,
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        isNumeric: false,
        id: 13,
        active: false,
        translationKey: "tagCode",
        columnId: COLUMN_TAG_CODE
    },
]

export default ZoneOccupanyColumns;
